<script setup lang="ts">
/**
 * Dot-grid pulse — techy dotted grid with radar pulses expanding from
 * fixed epicentres.
 */
const pulses = [
  { left: '22%', top: '38%', size: '340px', dur: '5.5s', delay: '0s' },
  { left: '68%', top: '30%', size: '420px', dur: '6.5s', delay: '-2.5s' },
  { left: '48%', top: '72%', size: '300px', dur: '7s', delay: '-4s' }
]
</script>

<template>
  <div
    class="site-hero-anim"
    aria-hidden="true"
  >
    <div class="site-anim-dotgrid" />
    <span
      v-for="(p, i) in pulses"
      :key="i"
      class="site-anim-radar -translate-x-1/2 -translate-y-1/2"
      :style="{
        'left': p.left,
        'top': p.top,
        'width': p.size,
        'height': p.size,
        '--dur': p.dur,
        'animation-delay': p.delay
      }"
    />
  </div>
</template>
